import { render, staticRenderFns } from "./SecondaryBar.vue?vue&type=template&id=53a58760&"
import script from "./SecondaryBar.vue?vue&type=script&lang=js&"
export * from "./SecondaryBar.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports